import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { Autocomplete } from '@material-ui/lab';
import { wsFindBy } from 'services/WService';
import { Checkbox, FormControlLabel, Switch, Tooltip } from '@material-ui/core';

//reemplazando valores de iniciales en estado

export default function ModalActivity(props) {
  const activity = props.model;

  return (
    <Modal
      title="Nueva Actividad"
      model={activity}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/activity-report"
      state
    >
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={activity.description || ''}
        required
      />
    </Modal>
  );
}
